var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-row',[_c('a-col',{attrs:{"span":24}},[_c('a-card',{staticStyle:{"margin":"10px 20px 10px 20px","padding":"20px"}},[_c('keytype-chart',{ref:"keytypeChart"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }